var map = {
	"./03b381.png": 2519,
	"./368bd6.png": 2520,
	"./ac3ba8.png": 2521,
	"./attach.png": 2522,
	"./call.png": 2523,
	"./cancel-black.png": 2524,
	"./cancel-black2.png": 2525,
	"./cancel.png": 2526,
	"./chevron-left.png": 2527,
	"./chevron-right.png": 2528,
	"./chevron.png": 2529,
	"./close-white.png": 2530,
	"./create-big.png": 2531,
	"./create.png": 2532,
	"./delete.png": 2533,
	"./directory-big.png": 2534,
	"./download.png": 2535,
	"./edit.png": 2536,
	"./file.png": 2537,
	"./filegrid.png": 2538,
	"./fileicon.png": 2539,
	"./filelist.png": 2540,
	"./files.png": 2541,
	"./hide.png": 2542,
	"./info.png": 2543,
	"./list-close.png": 2544,
	"./list-open.png": 2545,
	"./member_chevron.png": 2546,
	"./menu.png": 2547,
	"./newmessages.png": 2548,
	"./placeholder.png": 2549,
	"./search.png": 2550,
	"./selected.png": 2551,
	"./settings-big.png": 2552,
	"./settings.png": 2553,
	"./stickerpack-placeholder.png": 2554,
	"./trans.png": 2555,
	"./typing.png": 2556,
	"./upload-big.png": 2557,
	"./upload.png": 2558,
	"./video.png": 2559,
	"./voice.png": 2560,
	"./voip-mute.png": 2561,
	"./voip.png": 2562,
	"./warning.png": 2563,
	"./warning2.png": 2564,
	"./zoom.png": 2565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2518;